import { Empty } from 'antd';
import React from 'react';


export default ({ description }) => (<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={description} />)
